import { useReducer } from 'react'
import { validTokenExists } from './auth/token'
export const useAppReducer = () => useReducer(appReducer, initialAppState)

function appReducer(appState, action) {
    // console.log(`action => ${JSON.stringify(action, null, 4)}`)
    switch (action.name) {
        case 'logIn':
            return { ...appState, loggedIn: true }
        case 'logOut':
            return { ...appState, loggedIn: false, activeTab: 'listen' }
        case 'navigateTo':
            return { ...appState, activeTab: action.value }
        case 'removeTracks':
            return { ...appState, removeTracks: action.value }
        case 'setCurrentRoom':
            localStorage.setItem('currentRoom', action.value)
            return { ...appState, currentRoom: action.value }
        case 'showAlertModal':
            global.pushModal?.('alert', {
                text: action.value.text,
                okText: action.value.okText
            })
            return appState
        case 'showConfirmModal':
            global.pushModal?.('confirm', {
                text: action.value.text,
                confirmText: action.value.confirmText,
                confirmAction: action.value.confirmAction,
                cancelAction: action.value.cancelAction
            })
            return appState
        case 'showProgressModal':
            global.pushModal?.('progress', {
                text: action.value.text,
                action: action.value.action
            })
            return appState
        case 'setShowQueueDrawer':
            return { ...appState, showQueueDrawer: action.value }
        case 'showProfileModal':
            global.pushModal?.('profile')
            return appState
        case 'showSearchModal':
            global.pushModal?.('search')
            return appState
        case 'showYouTubeSearchModal':
            global.pushModal?.('youtubeSearch')
            return appState
        case 'showDigModal':
            global.pushModal?.('dig')
            return appState
        case 'showTrackModal':
            global.pushModal?.('track', { trackId: action.value })
            return appState
        case 'showRoomDetailsModal':
            global.pushModal?.('roomDetails', { roomId: action.value })
            return appState
        case 'showCreateRoomModal':
            global.pushModal?.('createRoom')
            return appState
        case 'showAlbumModal':
            global.pushModal?.('album', { albumData: action.value })
            return appState
        case 'showUploadModal':
            global.pushModal?.('upload')
            return appState
        case 'stopAudio':
            return { ...appState, stopAudioTimestamp: action.value ?? Date.now() }
        default:
            throw new Error(`Unexpected state in action: ${JSON.stringify(action)}`)
    }
}

export const Actions = {
    logIn: () => ({
        name: 'logIn'
    }),
    logOut: () => ({
        name: 'logOut'
    }),
    navigateTo: (dest) => ({
        name: 'navigateTo',
        value: dest
    }),
    removeTracks: (tracks) => ({
        name: 'removeTracks',
        value: tracks
    }),
    setCurrentRoom: (roomId) => ({
        name: 'setCurrentRoom',
        value: roomId
    }),
    showModal: (data) => ({
       name: 'showModal',
       value: data
    }),
    showAlertModal: (text, okText = 'OK') => ({
        name: 'showAlertModal',
        value: { text, okText }
    }),
    showConfirmModal: (text, confirmText, confirmAction, cancelAction) => ({
        name: 'showConfirmModal',
        value: { text, confirmText, confirmAction, cancelAction }
    }),
    showProgressModal: (text, action) => ({
        name: 'showProgressModal',
        value: { text, action }
    }),
    setShowQueueDrawer: (value) => ({
        name: 'setShowQueueDrawer',
        value
    }),
    showProfileModal: () => ({
        name: 'showProfileModal'
    }),
    showSearchModal: () => ({
        name: 'showSearchModal'
    }),
    showYouTubeSearchModal: () => ({
        name: 'showYouTubeSearchModal'
    }),
    showDigModal: () => ({
        name: 'showDigModal'
    }),
    showTrackModal: (trackId) => ({
        name: 'showTrackModal',
        value: trackId
    }),
    showRoomDetailsModal: (roomId) => ({
        name: 'showRoomDetailsModal',
        value: roomId
    }),
    showCreateRoomModal: () => ({
        name: 'showCreateRoomModal'
    }),
    showAlbumModal: (albumData) => ({
        name: 'showAlbumModal',
        value: albumData
    }),
    showUploadModal: () => ({
        name: 'showUploadModal'
    }),
    stopAudio: (timestamp) => ({
        name: 'stopAudio',
        value: timestamp
    })
}

const initialAppState = {
    activeTab: 'listen',
    currentRoom: null,
    loggedIn: validTokenExists(),
    removeTracks: [],
    stopAudioTimestamp: 0,
    showQueueDrawer: false,
}
